export function formatGPG(goals, appearances) {
  if (!appearances || appearances === 0) return '0.00';
  return (goals / appearances).toFixed(2);
}

export function hasKnownAppearances(player) {
  return Number(player?.total_appearances || player?.appearances || 0) > 0;
}

export function formatAppearances(player) {
  return hasKnownAppearances(player) ? String(player.total_appearances || player.appearances) : '—';
}

export function formatPlayerGPG(player) {
  if (!hasKnownAppearances(player)) return '—';
  if (typeof player.goals_per_game === 'number') return player.goals_per_game.toFixed(2);
  if (player.goals_per_game) return Number(player.goals_per_game).toFixed(2);
  return formatGPG(player.total_goals || player.goals || 0, player.total_appearances || player.appearances || 0);
}

export function formatNumber(num) {
  if (num === null || num === undefined) return '—';
  return num.toLocaleString();
}

export function getInitials(name) {
  if (!name) return '??';
  const parts = name
    .replace(/\([^)]*\)/g, '')
    .trim()
    .split(/\s+/)
    .map((part) => part.replace(/[^a-z0-9]/gi, ''))
    .filter(Boolean);
  if (parts.length === 0) return '??';
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function getInitialsColor(name) {
  if (!name) return 'bg-surface-container-highest';
  const colors = [
    'bg-primary/20 text-primary',
    'bg-secondary/20 text-secondary',
    'bg-tertiary/20 text-tertiary',
    'bg-error/20 text-error',
  ];
  const hash = name.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return colors[hash % colors.length];
}
